// External pages must leave the native WebView intact. A missing bridge in a
// packaged app must not trigger web navigation.
export default function openExternalPage(url) {
  if (window.cordova || process.env.PLATFORM === 'mobile') {
    if (!window.cordova || !window.cordova.InAppBrowser) {
      throw new Error('The native browser is unavailable. Please restart the app.');
    }
    window.cordova.InAppBrowser.open(url, '_system');
  } else {
    window.location.assign(url);
  }
}
